import React, { useEffect, useRef, useState } from 'react';
import { errorMessages } from '../HighlightsModal/components/validateKeyword';
import styles from './ExclusionModal.module.scss';
import ExclusionFormSection from './components/ExclusionFormSection';
import {
  Button,
  Message,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Text,
} from 'components/core';
import { Stack } from 'components/layout';
import { exclusionReasons } from 'pages/EligibilityCriteria/EligibilityCriteria';

const getAPIErrorMessage = (messages: string[]) => {
  if (messages.includes('must be unique')) {
    return errorMessages['duplicateKeyword'];
  }

  return 'Error saving changes. Please try again or refresh the page.';
};

type ExclusionModalProps = {
  isOpen: boolean;
  exclusionReasons: exclusionReasons;
  handleClose: () => void;
};

const ExclusionModal = ({
  isOpen,
  handleClose,
  exclusionReasons,
}: ExclusionModalProps) => {
  const [apiErrorMessages, setApiErrorMessagess] = useState<string[] | null>(
    null
  );
  const errorRef = useRef<HTMLDivElement | null>(null);
  const hasAPIError = Boolean(apiErrorMessages?.length);

  useEffect(() => {
    if (hasAPIError) {
      errorRef.current?.focus();
    }
  }, [hasAPIError]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      size="lg"
      aria-label="Edit exclusion reasons"
    >
      <ModalHeader>Edit exclusion reasons</ModalHeader>
      <ModalBody>
        <Stack spacing={5}>
          <Text variant="neutral">
            During full text review, you will need to select the reason why a
            study should not be included. Edit the list below to suit your
            review. We recommend ordering these in order of importance.
          </Text>

          <ExclusionFormSection
            title="Exclusion reason"
            label="Add exclusion reason"
            exclusions={exclusionReasons}
            onUpdate={() => {
              console.log('Update exclusion reasons');
            }}
            onApiError={(errors) => {
              setApiErrorMessagess(errors);
            }}
          />
        </Stack>

        <div role="alert" ref={errorRef} tabIndex={-1}>
          {hasAPIError && (
            <Message
              className={styles.apiErrorMessage}
              type="danger"
              variant="prominent"
              isVisible={hasAPIError}
              onClose={() => setApiErrorMessagess(null)}
            >
              <Text>{getAPIErrorMessage(apiErrorMessages || [])}</Text>
            </Message>
          )}
        </div>
      </ModalBody>
      <ModalFooter>
        <Button type="brand" onClick={handleClose}>
          Done
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ExclusionModal;
